import { render, staticRenderFns } from "./ErrorLayout.vue?vue&type=template&id=eb6cddba&scoped=true&"
var script = {}
import style0 from "./ErrorLayout.vue?vue&type=style&index=0&id=eb6cddba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6cddba",
  null
  
)

export default component.exports